import { countryToISO } from "../../utils/countryToISO";
import { getCountryName } from "../../utils/getCountryName";
import { getShipFromCountryForBrand } from "../../utils/getShippingFromCountryForBrand";
import { isSWFAvailableInCountry } from "../../utils/isSWFAvailableInCountry";
export var SwfAvailability = function SwfAvailability(strictLocalize) {
  return {
    descriptionBuilder: function descriptionBuilder(context) {
      return isSWFAvailableDescriptionBuilder(context, strictLocalize);
    }
  };
};
var isSWFAvailableDescriptionBuilder = function isSWFAvailableDescriptionBuilder(context, strictLocalize) {
  var _context$brandOrder$b, _context$brandOrder, _context$brandOrder$b2, _context$brandOrder$b3;
  var shipFromCountry = (_context$brandOrder$b = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b2 = _context$brandOrder.brand_order) === null || _context$brandOrder$b2 === void 0 ? void 0 : (_context$brandOrder$b3 = _context$brandOrder$b2.ship_from_address) === null || _context$brandOrder$b3 === void 0 ? void 0 : _context$brandOrder$b3.country) !== null && _context$brandOrder$b !== void 0 ? _context$brandOrder$b : getShipFromCountryForBrand(context.brand);
  var shipFromCountryISO = countryToISO(shipFromCountry);
  var shipFromCountryName = getCountryName(shipFromCountryISO, strictLocalize);
  return isSWFAvailableInCountry(shipFromCountryISO) ? [SWF_AVAILABLE_IN_COUNTRY(strictLocalize, shipFromCountryName)] : [SWF_NOT_AVAILABLE_IN_COUNTRY(strictLocalize, shipFromCountryName)];
};
var SWF_AVAILABLE_IN_COUNTRY = function SWF_AVAILABLE_IN_COUNTRY(strictLocalize, countryName) {
  return strictLocalize({
    id: "e24tfN",
    defaultMessage: [{
      "type": 0,
      "value": "Verzenden met Faire is beschikbaar in "
    }, {
      "type": 1,
      "value": "countryFullyTranslatedSentence"
    }, {
      "type": 0,
      "value": "."
    }]
  }, {
    countryFullyTranslatedSentence: countryName !== null && countryName !== void 0 ? countryName : "(unknown)"
  });
};
var SWF_NOT_AVAILABLE_IN_COUNTRY = function SWF_NOT_AVAILABLE_IN_COUNTRY(strictLocalize, countryName) {
  return strictLocalize({
    id: "//lW8Y",
    defaultMessage: [{
      "type": 0,
      "value": "Verzenden met Faire is niet beschikbaar in "
    }, {
      "type": 1,
      "value": "countryFullyTranslatedSentence"
    }, {
      "type": 0,
      "value": "."
    }]
  }, {
    countryFullyTranslatedSentence: countryName !== null && countryName !== void 0 ? countryName : "(unknown)"
  });
};